"use client";

import { ChevronRight, RotateCcw } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
export default function Capabilities() {
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="16573" id="quickactiongrid" className="bg-white py-24 md:py-32 overflow-hidden">
      <div className="mx-auto w-full max-w-[1280px] px-5 sm:px-8 md:px-14">
        <div className="grid grid-cols-1 gap-12 items-center">
          <div ref={grid.ref} className={`transition-all duration-700 ease-out delay-200 ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="bg-white p-8 md:p-10 rounded-lg shadow-sm border border-[#E5E7EB] max-w-3xl mx-auto">
              <div className="mb-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="h-[2px] w-12 bg-[#B30000]" />
                  <p className="text-xs font-bold uppercase tracking-widest text-[#B30000]">
                    Zona Pemuda Pancasila
                  </p>
                </div>
                <h1 className="font-sans font-bold text-foreground text-3xl md:text-4xl tracking-tight leading-tight">
                  PILIH WILAYAH ORGANISASI
                </h1>
              </div>

              <div className="space-y-4">
                <div data-index={0}>
                  <Select defaultValue="MPC">
                    <SelectTrigger className="w-full h-14 text-base border-border bg-white rounded-lg shadow-sm focus:ring-[#B30000] focus:border-[#B30000] transition-all">
                      <SelectValue placeholder="Tingkat Organisasi" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-border rounded-lg shadow-xl">
                      <SelectItem value="MPN">MPN (Nasional)</SelectItem>
                      <SelectItem value="MPW">MPW (Provinsi)</SelectItem>
                      <SelectItem value="MPC">MPC (Kabupaten/Kota)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div data-index={1}>
                  <Select defaultValue="Jawa Barat">
                    <SelectTrigger className="w-full h-14 text-base border-border bg-white rounded-lg shadow-sm focus:ring-[#B30000] focus:border-[#B30000] transition-all">
                      <SelectValue placeholder="Provinsi" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-border rounded-lg shadow-xl">
                      <SelectItem value="Jawa Barat">Jawa Barat</SelectItem>
                      <SelectItem value="Jawa Tengah">Jawa Tengah</SelectItem>
                      <SelectItem value="Jawa Timur">Jawa Timur</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div data-index={2}>
                  <Select defaultValue="Garut">
                    <SelectTrigger className="w-full h-14 text-base border-border bg-white rounded-lg shadow-sm focus:ring-[#B30000] focus:border-[#B30000] transition-all">
                      <SelectValue placeholder="Kabupaten/Kota" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-border rounded-lg shadow-xl">
                      <SelectItem value="Garut">Garut</SelectItem>
                      <SelectItem value="Bandung">Bandung</SelectItem>
                      <SelectItem value="Bogor">Bogor</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div data-index={3}>
                  <Select>
                    <SelectTrigger className="w-full h-14 text-base border-border bg-white rounded-lg shadow-sm focus:ring-[#B30000] focus:border-[#B30000] transition-all">
                      <SelectValue placeholder="Kecamatan" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-border rounded-lg shadow-xl">
                      <SelectItem value="kec1">Kecamatan A</SelectItem>
                      <SelectItem value="kec2">Kecamatan B</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div data-index={4}>
                  <Select>
                    <SelectTrigger className="w-full h-14 text-base border-border bg-white rounded-lg shadow-sm focus:ring-[#B30000] focus:border-[#B30000] transition-all">
                      <SelectValue placeholder="Desa/Kelurahan" />
                    </SelectTrigger>
                    <SelectContent className="bg-white border-border rounded-lg shadow-xl">
                      <SelectItem value="desa1">Desa A</SelectItem>
                      <SelectItem value="desa2">Desa B</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-end gap-4 pt-6">
                  <p className="text-sm font-medium text-muted-foreground mr-auto">
                    Wilayah Aktif: <span className="text-foreground">Belum Dipilih</span>
                  </p>
                  <div className="flex items-center gap-3 w-full sm:w-auto">
                    <Button variant="outline" className="flex-1 sm:flex-none border-border hover:bg-muted text-foreground font-bold rounded-lg px-6 py-6 h-auto flex items-center gap-2 transition-all duration-300">
                      <RotateCcw className="size-5" />
                      Reset Wilayah
                    </Button>
                    <Button className="flex-1 sm:flex-none bg-[#EB7C2D] hover:bg-[#EB7C2D]/90 text-white font-bold rounded-lg px-8 py-6 h-auto flex items-center gap-2 transition-all duration-300 group">
                      Tampilkan Wilayah
                      <ChevronRight className="size-5 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-border/50">
                <div className="flex items-center gap-4 text-xs text-muted-foreground">
                  <div className="flex -space-x-2">
                    <div className="size-6 rounded-lg bg-[#B30000] border-2 border-white" />
                    <div className="size-6 rounded-lg bg-[#D4AF37] border-2 border-white" />
                    <div className="size-6 rounded-lg bg-[#111111] border-2 border-white" />
                  </div>
                  <span>Terintegrasi dengan 27 Subdomain Nasional</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}